import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

import { AppState } from 'services/types';
import formatDropdownOptions from 'utils/format-dropdown-options';
import { ActiveIngredientsState, ActiveIngredient } from './types';

const selectActiveIngredients = (state: AppState): ActiveIngredientsState =>
    state.activeIngredients;

const selectActiveIngredientsArray = createDeepEqualSelector(
    selectActiveIngredients,
    (activeIngredients) => Object.values(activeIngredients)
);

const selectActiveActiveIngredients = createDeepEqualSelector(
    selectActiveIngredientsArray,
    (activeIngredients): ActiveIngredient[] =>
        activeIngredients.filter(
            (activeIngredient) => activeIngredient.deletedAt === null
        )
);

const selectActiveIngredientsOptions = createDeepEqualSelector(
    selectActiveActiveIngredients,
    (activeIngredients) =>
        formatDropdownOptions(activeIngredients, {
            keyField: 'id',
            textField: 'name'
        })
);

export {
    selectActiveIngredients,
    selectActiveIngredientsArray,
    selectActiveActiveIngredients,
    selectActiveIngredientsOptions
};
